var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgItalic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3L11.876 3.465C11.705 3.47 11.482 3.491 11.207 3.528C10.931 3.566 10.727 3.602 10.595 3.634C10.363 3.695 10.198 3.789 10.099 3.916C10 4.043 9.928 4.183 9.883 4.335L7.894 11.642C7.883 11.673 7.875 11.71 7.869 11.752C7.864 11.795 7.861 11.833 7.861 11.865C7.861 11.974 7.888 12.065 7.943 12.14C7.999 12.215 8.098 12.281 8.241 12.337C8.324 12.371 8.506 12.409 8.787 12.454C9.068 12.499 9.277 12.525 9.415 12.535L9.291 13H4L4.124 12.535C4.278 12.525 4.499 12.511 4.785 12.493C5.072 12.474 5.276 12.446 5.397 12.408C5.612 12.342 5.775 12.252 5.885 12.137C5.995 12.021 6.069 11.882 6.108 11.717L8.092 4.402C8.103 4.36 8.111 4.318 8.116 4.275C8.123 4.233 8.125 4.191 8.125 4.149C8.125 4.055 8.102 3.973 8.054 3.902C8.007 3.832 7.91 3.768 7.761 3.712C7.612 3.655 7.41 3.603 7.153 3.553C6.897 3.504 6.708 3.475 6.587 3.465L6.711 3H12Z",
    fill: "#73777C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgItalic);
export default __webpack_public_path__ + "static/media/italic.8c65474378760b98f6b741313ee88e5b.svg";
export { ForwardRef as ReactComponent };